export const productivityNavigationTranslations = {
  ar: { 'Page hierarchy': 'تسلسل الصفحات' },
  tr: { 'Page hierarchy': 'Sayfa hiyerarşisi' },
}
